import React, { useState, useEffect } from "react";
import style from "./settingInvoice.module.scss"
import SuccessToast from "../../successToast/Toast";
import Button from "../../Button/button"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { withRouter } from "react-router-dom";
import numberWithCommas from "../../../helpers/actions/numberWithCommas";
import { GetWalletInvoice } from "../../../actions/APIcalls"
import Skeleton from "./skeleton"

const SettingInvoice = (props) => {

    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [invoiceDetails, setInvoiceDetails] = useState({
        pricingCount: 0,
        remainDay: 0,
        walletAmount: 0,
    })

    useEffect(async () => {
        setHasSkeleton(true)
        await GetInvoice()
        setHasSkeleton(false)
    }, []);

    const GetInvoice = async () => {
        let res = await GetWalletInvoice()
        if (res && res.data) {
            let tmp = res.data;
            setInvoiceDetails({ ...tmp })
        }
    }

    const determineTitle = () => {
        let title = ''
        if (parseInt(invoiceDetails.remainDay.remain) < 1 || invoiceDetails.remainDay.type !== 'day') {
            title = `موجودی کیف پول برای کمتر از ۱ روز (${toPersianNumber(numberWithCommas(invoiceDetails.pricingCount))} مرتبه) کافی است.`
        }
        if (invoiceDetails.remainDay.type == 'day' && parseInt(invoiceDetails.remainDay.remain) >= 1) {
            title = `موجودی کیف پول برای ${toPersianNumber(numberWithCommas(invoiceDetails.remainDay.remain))} روز کافی است.`
        }

        if (parseInt(invoiceDetails.walletAmount) < 1000) {
            title = `پس از شارژ کیف پول، ربات با تنظیمات زیر شروع به کار می‌کند.`
        }
        return title
    }

    const chargeWallet = () => {
        props.history.push({
            pathname: '/chargewallet',
            state: {
                totalPrice: props.location && props.location.state && props.location.state.totalPrice ? props.location.state.totalPrice : 0
            }
        })
    }

    if (hasSkeleton) {
        return (<Skeleton />)
    } else {
        return (
            <div className={style.wrapper}>
                <div className={style.header}>
                    <h1>تنظیمات</h1>
                </div>

                <div className={style.toastWrapper}>
                    <SuccessToast value={true}>
                        <p>تغییرات مورد نظر با موفقیت اعمال شد.</p>
                    </SuccessToast>
                </div>

                <div className={style.invoiceDetailWrapper}>

                    <div className={style.titleWrapper}>
                        <div className={style.icon}></div>
                        {/* <div className={style.title}>پس از شارژ کیف پول، ربات با تنظیمات زیر شروع به کار می‌کند.</div> */}
                        <div className={style.title}>{determineTitle()}</div>
                    </div>

                    <div className={style.titleWrapper}>
                        <div className={style.labelWrapper}>
                            <div className={style.labelStyle}>بازه‌ی قیمت‌گذاری:</div>
                            <div className={style.textStyle}> {props.location && props.location.state ? toPersianNumber(props.location.state.timeRange) : '-'} دقیقه</div>
                            {/* <div className={style.descStyle}> ({props.location && props.location.state ? toPersianNumber(props.location.state.perPrice) : '-'} ریال به ازای یک بار بررسی هر تنوع)</div> */}
                        </div>
                        <div className={style.labelWrapper}>
                            <div className={style.labelStyle}>تعداد تنوع:</div>
                            <div className={style.textStyle}>{props.location && props.location.state ? toPersianNumber(numberWithCommas(props.location.state.variantCount)) : '-'} تنوع</div>
                        </div>
                    </div>

                    <div className={style.titleWrapper}>
                        <div className={style.verticalBorder}></div>
                    </div>

                    <div className={style.subDescWrapper}>
                        <div className={style.boldPriceTitle}>جمع کل:</div>
                        <div className={style.boldPrice}>{props.location && props.location.state ? toPersianNumber(numberWithCommas(parseInt(props.location.state.totalPrice))) : '-'} تومان</div>
                        <div className={style.boldPriceDesc}>(ماهانه)</div>
                    </div>

                    <div className={style.subDescWrapper}>
                        <div className={style.boldPriceDesc}>(بدون احتساب تنوع‌های با بازه‌ی قیمت‌گذاری متفاوت)</div>
                    </div>

                    <div className={style.subDescWrapper}>
                        <div className={style.normalPriceTitle}>موجودی کیف پول:</div>
                        {parseInt(invoiceDetails.walletAmount / 10) < 0 ? <div className={style.normalPrice}>۰ تومان</div> : <div className={style.normalPrice}>{toPersianNumber(numberWithCommas(parseInt(invoiceDetails.walletAmount / 10)))} تومان</div>}
                    </div>

                    <div className={style.subDescWrapper}>
                        <div className={style.boldPriceDesc}>
                            <p>جمع کل اعلامی، تخمینی برای تعداد تنوع وارد شده توسط شماست.</p>
                            <p>در هر بار قیمت‌گذاری به اندازه‌ی مبلغ اعلام شده، از کیف پول شما کسر خواهد شد.</p>
                        </div>
                    </div>

                    <div className={style.ButtonWrapper}>
                        <Button
                            type='solid'
                            disabled={false}
                            label='شارژ کیف پول'
                            onclick={chargeWallet}
                        />
                    </div>

                </div>
            </div>
        );
    }
}

export default withRouter(SettingInvoice);
